import React, { FC } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

interface DeleteConfirmationModalProps {
  open: boolean;
  title?: string;
  message?: string;
  itemName?: string;
  itemType?: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

export const DeleteConfirmationModal: FC<DeleteConfirmationModalProps> = ({
  open,
  title = 'Confirm Delete',
  message,
  itemName,
  itemType = 'item',
  onConfirm,
  onCancel,
  loading = false,
}) => {
  const defaultMessage = itemName
    ? `Are you sure you want to delete "${itemName}"? This action cannot be undone.`
    : `Are you sure you want to delete this ${itemType}? This action cannot be undone.`;

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
      aria-labelledby="delete-confirmation-dialog-title"
    >
      <DialogTitle id="delete-confirmation-dialog-title">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" component="div">
            {title}
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onCancel}
            size="small"
            disabled={loading}
          >
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      
      <DialogContent>
        <Typography variant="body1" color="textPrimary">
          {message || defaultMessage}
        </Typography>
      </DialogContent>

      <DialogActions style={{ padding: '16px 24px' }}>
        <Button
          onClick={onCancel}
          color="default"
          variant="outlined"
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="secondary"
          variant="contained"
          disabled={loading}
          style={{ 
            backgroundColor: '#dc3545', 
            color: '#fff',
            marginLeft: '8px'
          }}
        >
          {loading ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationModal;
